// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"862d1497","116":"af38be3d","339":"3416b25d","352":"53ca0776","481":"bdce2c18","516":"5e6236df","664":"8b3acfc9"}[chunkId] + ".chunk.js";
};